import React, { useState } from 'react';
import { Typography, InputBase, Button, Box, Grid } from '@mui/material';
import PasswordGuidelines from '~/_base/components/passwordGuidelines';



export default function CompleteSetup() {
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  function handleRequestPasswordClick() {
    document.getElementsByTagName('form')[0].submit();
  }

  function handleKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      handleRequestPasswordClick();
    }
  }

  function shouldRender() {
    const elements = document.querySelectorAll(
      "[data-mount='ape_password_complete_setup']"
    );
    return elements.length > 0;
  }

  if (!shouldRender()) {
    return <Box />;
  } else
    return (
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <PasswordGuidelines />
        </Grid>
        <Grid size={{xs: 12, sm: 6, md: 6}}>
          <Typography variant="h1" mb={2}>
            Please enter a password to complete the setup
          </Typography>
          <Box mb={1}>
            <InputBase
              onKeyPress={handleKeyPress}
              id="user_password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              name="user[password]"
              type="password"
              fullWidth
              placeholder="New password"
            />
          </Box>
          <Box mb={1}>
            <InputBase
              onKeyPress={handleKeyPress}
              id="user_password_confirmation"
              value={passwordConfirm}
              onChange={e => setPasswordConfirm(e.target.value)}
              name="user[password_confirmation]"
              type="password"
              fullWidth
              placeholder="Password confirmation"
            />
          </Box>
          <Box className="buttonContainer">
            <Button
              variant="contained"
              color="primary"
              fullWidth
              type="button"
              onClick={() => handleRequestPasswordClick()}
            >
              Set Password
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
}
